/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RoleEnum {
    Provider = 10,
    Client = 20,
    Admin = 30,
    Bank = 40,
}
